import { Column, Row, Text } from '~/commonComponents';
import { SelectedDatePill } from './SelectedDatePill';

interface ISelectedDatesListProps {
  dates: Date[];
  onRemoveDate: (date: Date) => void;
}

export const SelectedDatesList = ({ dates, onRemoveDate }: ISelectedDatesListProps) => {
  const sortedDates = [...dates].sort((a, b) => a.getTime() - b.getTime());

  return (
    <Column>
      <Text bold fontSize={18}>
        Selected Dates ({dates.length})
      </Text>
      <Row flexWrap="wrap" gap={10} marginTop={24}>
        {sortedDates.map((date) => (
          <SelectedDatePill
            key={date.toISOString()}
            date={date}
            onRemove={() => onRemoveDate(date)}
          />
        ))}
      </Row>
    </Column>
  );
};
